'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeapAnalytics = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
/* eslint-disable */


var _lodash = require('lodash.debounce');

var _lodash2 = _interopRequireDefault(_lodash);

var _logging = require('@quid-private/quid-client/lib/logging');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var HeapAnalytics = exports.HeapAnalytics = function () {
  function HeapAnalytics() {
    _classCallCheck(this, HeapAnalytics);
  }

  _createClass(HeapAnalytics, null, [{
    key: 'inject',
    // prettier-ignore
    value: function inject() {
      var me = this;
      window.isHeapLoadProcessStarted = false;
      window.heap = window.heap || [];

      for (var o = function o(e) {
        return function () {
          heap.push([e].concat(Array.prototype.slice.call(arguments, 0)));
        };
      }, p = ["addEventProperties", "addUserProperties", "clearEventProperties", "identify", "removeEventProperty", "setEventProperties", "track", "unsetEventProperty"], c = 0; c < p.length; c++) {
        heap[p[c]] = o(p[c]), heap.load = function (e, t) {
          window.heap.appid = e, window.heap.config = t = t || {};
          var r = t.forceSSL || "https:" === document.location.protocol,
              a = document.createElement("script");
          a.type = "text/javascript", a.async = !0, a.src = (r ? "https:" : "http:") + "//cdn.heapanalytics.com/js/heap-" + e + ".js";
          /* added by us START */

          me.saveHeapReferenceOnLoad(a);
          /* END */

          var n = document.getElementsByTagName("script")[0];
          n.parentNode.insertBefore(a, n);
        };
      }
    } // Configures interval between bulk sends of events.

  }, {
    key: 'initialize',
    value: function initialize() {
      if (window.heap !== undefined) {
        console.error('You are trying to initialize Heap Analytics more than once');
      } else {
        HeapAnalytics.inject();
        this._heap = window.heap;
      }
    }
  }, {
    key: 'configure',
    value: function configure(trackingId, userId) {
      var heap = this._heap;

      if (window.isHeapLoadProcessStarted === false) {
        heap.load(trackingId);
        window.isHeapLoadProcessStarted = true;
      }

      if (userId !== null) {
        // must be a string
        heap.identify(userId + '');
      }
    }
  }, {
    key: 'saveHeapReferenceOnLoad',
    value: function saveHeapReferenceOnLoad(script) {
      var _this = this;

      script.addEventListener('load', function () {
        _this._heap = window.heap;
      });
    }
  }, {
    key: 'addUserProperties',
    value: function addUserProperties(properties) {
      this._heap.addUserProperties(properties);
    }
  }, {
    key: 'addContext',
    value: function addContext(context) {
      this._heap.addEventProperties(context);
    }
  }, {
    key: 'clearContext',
    value: function clearContext() {
      this._heap.clearEventProperties();
    }
  }, {
    key: 'setContext',
    value: function setContext(context) {
      this.clearContext();
      this.addContext(context);
    }
  }, {
    key: 'sendEvent',
    value: function sendEvent(name, properties) {
      this._heap.track(name, properties);
    }
  }, {
    key: 'flushQueue',
    value: function flushQueue() {
      return new Promise(function ($return, $error) {
        if (this.eventQueue.length) {
          var $Try_1_Post = function () {
            try {
              return $If_2.call(this);
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }.bind(this);

          var $Try_1_Catch = function (e) {
            try {
              // Retry.
              this.requestFlush();
              return $Try_1_Post();
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }.bind(this);

          try {
            return Promise.resolve((0, _logging.sendHeapBatch)({
              events: this.eventQueue
            })).then(function ($await_3) {
              try {
                this.eventQueue.length = 0;
                return $Try_1_Post();
              } catch ($boundEx) {
                return $Try_1_Catch($boundEx);
              }
            }.bind(this), $Try_1_Catch);
          } catch (e) {
            $Try_1_Catch(e);
          }
        }

        function $If_2() {
          return $return();
        }

        return $If_2.call(this);
      }.bind(this));
    }
  }, {
    key: 'sendBulkEvent',
    value: function sendBulkEvent(name, properties) {
      var date = new Date();
      this.eventQueue.push({
        event: name,
        identity: this._heap.identity,
        timestamp: date.toISOString(),
        properties: properties
      });
      this.requestFlush();
    }
  }]);

  return HeapAnalytics;
}();

HeapAnalytics.BULK_INTERVAL_MS = 3000;
HeapAnalytics.eventQueue = [];
HeapAnalytics.requestFlush = (0, _lodash2.default)(function () {
  // Send events if we have one.
  // Use the static name because debounce loses the "this" binding.
  if (HeapAnalytics.eventQueue.length) {
    HeapAnalytics.flushQueue();
  }
}, HeapAnalytics.BULK_INTERVAL_MS);